import React from "react";

export default function WhatsAppFloat() {
    return (
        <a
            href="https://wa.me/353872922619"
            className="whatsapp-float"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contact via WhatsApp"
            title="Chat on WhatsApp"
        >
            💬
        </a>
    );
}
